import { NgModule } from '@angular/core';
import { LoupeAngularComponent } from './loupe-angular.component';



@NgModule({
  declarations: [LoupeAngularComponent],
  imports: [
  ],
  exports: [LoupeAngularComponent]
})
export class LoupeAngularModule { }
